<template>
  <div class="content">
    <div class="bodycontent">
      <!-- 头部菜单 -->
      <div class="option">
        <div class="left">
          <el-button type="primary" @click="addVipLevel()" icon="el-icon-plus" size="small">添加车队卡</el-button>
          <el-button style="margin-left:30px" @click="gotoRecord()" size="small">开卡记录</el-button>
        </div>
        <div class="right">
          <span>
            是否显示
            <el-select v-model="is_show" placeholder="是否显示" clearable size="small">
              <el-option label="显示" value="1"></el-option>
              <el-option label="隐藏" value="0"></el-option>
            </el-select>
          </span>
          <span>
            <el-input
              type="text"
              placeholder="等级名称"
              v-model="keyword"
              style="width:180px"
              clearable
              size="small"
            />
          </span>
          <span>
            <el-button type="primary" @click="search()" size="small">搜索</el-button>
          </span>
        </div>
      </div>
      <!-- 会员卡等级列表 -->
      <el-table :data="listData" v-if="menus=='会员卡'" height="100%">
        <el-table-column label="等级图标" v-if="showTableItems[0].show">
          <template slot-scope="scope">
            <div>
              <img :src="scope.row.icon_url" alt="" class="level_img">
            </div>
          </template>
        </el-table-column>
        <el-table-column label="等级名称" prop="name" v-if="showTableItems[1].show"></el-table-column>
        <el-table-column label="等级" prop="grade" v-if="showTableItems[2].show"></el-table-column>
        <el-table-column label="享受折扣" prop="show_discount" v-if="showTableItems[3].show"></el-table-column>
        <el-table-column label="有效时间" prop="show_valid_date" v-if="showTableItems[4].show"></el-table-column>
        <!-- <el-table-column label="是否永久" prop="show_is_forever"></el-table-column> -->
        <el-table-column label="是否付费" prop="show_is_pay" v-if="showTableItems[5].show"></el-table-column>
        <el-table-column label="是否显示" prop="show_is_show" v-if="showTableItems[6].show"></el-table-column>
        <el-table-column label="等级说明" prop="explain" v-if="showTableItems[7].show"></el-table-column>
        <el-table-column width="165px" label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="update(scope.row.id)">升级任务</el-button>
            <el-button type="text" @click="editItemLevel(scope.row.id)">编辑</el-button>
            <el-button type="text" @click="delItemLevel(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
        <el-table-column width="70px;">
          <template slot="header">
            <el-popover
              placement="bottom"
              width="120"
              trigger="click">
              <el-checkbox style="margin-bottom:10px" v-for="(item,index) in showTableItems" :key="index" v-model="item.show">{{item.name}}</el-checkbox>
              <el-button slot="reference" size="small" icon="el-icon-s-unfold"></el-button>
            </el-popover>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页按钮 -->
      <div class="Otherpage">
        <el-pagination
          layout="prev, pager, next, total, jumper"
          :current-page="page"
          :total="total"
          :page-size="10"
          @current-change="handleCurrentChange">
        </el-pagination>
      </div>
      <!-- 任务列表 -->
      <el-dialog :visible.sync="showTaskList" @close="showTaskList=false" width="600px" title="升级任务">
        <el-table :data="taskList" v-loading="loading">
          <el-table-column label="任务内容" prop="name"></el-table-column>
          <el-table-column label="任务说明" prop="illustrate"></el-table-column>
          <el-table-column label="是否必须达成" width="105px">
            <template slot-scope="scope">
              <div>{{scope.row.is_must == 1? "是":"否"}}</div>
            </template>
          </el-table-column>
          <el-table-column width="100px" label="操作" align="right">
            <template slot-scope="scope">
              <div>
                <el-button type="text" @click="EditTask(scope.row)">编辑</el-button>
                <el-button type="text" @click="DelTask(scope.row.id)">删除</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-button style="width:100%;margin-top:10px;" type="primary" @click="newTask()">新建升级任务</el-button>
      </el-dialog>
      <!-- 任务设置 -->
      <el-dialog :visible.sync="showUpdate" @close="showUpdate=false" width="550px" title="升级条件">
        <el-form v-model="updateForm" label-width="103px" class="task_form">
          <el-form-item label="任务类型">
            <el-select v-model="updateForm.task_type" placeholder="请选择" class="normal_input">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="限定数量">
            <el-input v-model="updateForm.number" class="short_input"></el-input>
          </el-form-item>
          <el-form-item label="排序">
            <el-input v-model="updateForm.sort" class="short_input"></el-input>
          </el-form-item>
          <el-form-item label="是否显示">
            <el-radio-group v-model="updateForm.is_show">
              <el-radio :label="1">显示</el-radio>
              <el-radio :label="0">隐藏</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="是否务必达成">
            <el-radio-group v-model="updateForm.is_must">
              <el-radio :label="1">务必达成</el-radio>
              <el-radio :label="0">完成其一</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="任务说明">
            <el-input type="textarea" rows="3" v-model="updateForm.illustrate" class="normal_input"></el-input>
          </el-form-item>
        </el-form>
        <div class="bottom_btn">
          <el-button type="primary" @click="saveTask()">提交</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { vipList,delList,taskTypeList,getTaskList,addTask,editTask,delTask } from "@/api/vip"
export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  data() {
    return {
      is_show: "", //类型筛选 
      listData: [], //会员卡等级列表
      numCardList: [], //次卡列表
      keyword: "", //关键字筛选
      page: 1,
      total: 0,
      menus: "会员卡", 
      showTaskList: false, //升级任务列表
      taskList: [], //升级任务列表
      showUpdate: false, //设置升级条件
      loading: false, //任务列表loading
      new_update: true, //是否是新增升级条件
      updateForm: {
        number: "",
        sort: "",
        is_show: true,
        is_must: true,
      },  //升级条件表单
      options: [], //任务类型
      level_id: 0, //编辑任务时，选择的等级id
      showTableItems: [
        {name: '等级图标',show: true},
        {name: '等级名称',show: true},
        {name: '等级',show: true},
        {name: '享受折扣',show: true},
        {name: '有效时间',show: true},
        {name: '是否付费',show: true},
        {name: '是否显示',show: true},
        {name: '等级说明',show: true},
      ], //显示表格的列
    };
  },
  mounted() {
    // this.getData();
  },
  methods: {
    getData(){
      var data = {
        token: this.token,
        app_id: this.app_id,
        page: this.page,
        name: this.keyword,
        is_show:this.is_show
      }
      vipList(data).then(res=>{
        console.log(res);
        this.listData = res.data;
        this.listData.forEach(item=>{
          item.show_is_forever = item.is_forever == 1? "永久":"免费";
          item.show_is_pay = item.is_pay == 1? "付费":"免费";
          item.show_is_show = item.is_show == 1? "显示":"隐藏";
          item.show_valid_date = item.is_forever == 1? "永久有效":item.valid_date;
          item.show_discount = item.discount == '100'? "无":Number(item.discount)/10
        })
        this.total = res.total;
      })
      taskTypeList({token:this.token,app_id:this.app_id}).then(res=>{
        if(res.code == 200){
          this.options = res.data;
        }else{
          this.$message(res.msg)
        }
      })
    },
    //升级任务
    update(id){
      // this.showUpdate = true;
      this.showTaskList = true;
      this.loading = true;
      this.level_id = id;
      var data = {
        token: this.token,
        app_id: this.app_id,
        level_id: id,
      }
      getTaskList(data).then(res=>{
        this.taskList = res.data;
        this.loading = false;
        if(res.code != 200){
          this.$message({
            type: "warning",
            message: res.msg
          })
        }
      })
    },
    newTask(){
      this.updateForm = {
        is_show: 1,
        is_must: 1
      };
      this.showUpdate=true;
      this.new_update = true;
    },
    //编辑升级任务
    EditTask(row){
      this.updateForm = Object.assign({},row);
      this.showUpdate = true;
      this.new_update = false;
    },
    //删除升级任务
    DelTask(i){
      this.$confirm('确定删除？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        var data = {
          token:this.token,
          app_id:this.app_id,
          id:i
        }
        delTask(data).then(res=>{
          if(res.code == 200){
            this.$message({
              type:"success",
              message:"删除成功"
            })
            this.update(this.level_id);
          }else{
            this.$message({
              type:"error",
              message: res.msg
            })
          }
        })
      }).catch();
    },
    //保存升级任务
    saveTask(){
      var data = Object.assign({},this.updateForm);
      data.token = this.token;
      data.app_id = this.app_id;
      data.level_id = this.level_id;
      console.log(data);
      if(this.new_update){
        addTask(data).then(res=>{
          if(res.code == 200){
            this.$message({
              type: "success",
              message: res.msg
            })
            this.showUpdate = false;
            this.update(this.level_id);
          }else{
            this.$message({
              type: "error",
              message: res.msg
            })
          }
        })
      }else{
        delete data.create_time;
        delete data.level;
        delete data.name;
        editTask(data).then(res=>{
          if(res.code == 200){
            this.$message({
              type: "success",
              message: res.msg
            })
            this.showUpdate = false;
            this.update(this.level_id);
          }else{
            this.$message({
              type: "error",
              message: res.msg
            })
          }
        })
      }
    },
    // 搜索
    search() {
      this.page = 1;
      this.getData();
    },
    //添加会员卡
    addVipLevel(){
      this.$router.push('vipAdd');
    },
    //新建次卡
    addNumCard(){
      this.$router.push('addNumCard');
    },
    //跳页
    handleCurrentChange(p){
      this.page = p;
      this.getData();
    },
    //编辑会员等级
    editItemLevel(id){
      this.$router.push({path:'vipAdd',query:{vid:id}});
    },
    //删除会员等级
    delItemLevel(i){
      this.$confirm('确定删除？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        var data = {
          token:this.token,
          app_id:this.app_id,
          id:i
        }
        delList(data).then(res=>{
          if(res.code == 200){
            this.$message({
              type:"success",
              message:"删除成功"
            })
            this.getData();
          }else{
            this.$message({
              type:"error",
              message: res.msg
            })
          }
        })
      }).catch();
    },
    // 跳转开卡记录
    gotoRecord(){
      this.$router.push('motorcadeRecord');
    },
  }
};
</script>
<style lang="scss" scoped>
.content {
  padding: 10px 15px;
  height: 100%;
  background: #f1f2f6;
  overflow: auto;
  .bodycontent {
    position: relative;
    padding: 0px 27px 0;
    font-size: 14px;
    background: #fff;
    height: 100%;
    display: flex;
    flex-direction: column;
    .option {
      height: 79px;
      line-height: 79px;
      display: flex;
      .left {
        flex: 1;
      }
      .right {
        text-align: right;
        span{
          margin-left: 30px;
          .el-select{
            width:150px;
          }
        }
      }
    }
    // table
    .el-table {
      flex:1;
      box-shadow: 0 0 3px #f1f1f1;
      padding-left: 10px;
    }
    .level_img{
      width:60px;
      height: 60px;
    }
    .table_checkbox{
      margin-bottom: 10px;
    }
    //表格中的商品内容
    .table_line{
      height: 20px;
      line-height: 20px;
      overflow:hidden;
      text-overflow:ellipsis;
      white-space:nowrap;
    }
    //分页
    .Otherpage {
      height: 34px;
      width: 200px;
      line-height: 34px;
    }
    .task_form {
      margin-right: 20px;
      .short_input{
        width: 110px;
      }
      .normal_input{
        width: 350px;
      }
    }
    .bottom_btn{
      margin: 20px auto 0 auto;
      text-align: center;
    }
  }
}
</style>
